import Table from 'src/javascripts/components/Table';

export default class AccountsRestrictedAssetsIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // On select of a typeahead suggestion
    $('.restricted-assets-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let params = {};
      params['company_id'] = suggestion.value;
      $.ajax({
        type: "POST",
        dataType: "application/json",
        url: '/' + accountUrl + '/restricted_assets?' + $.param(params),
        complete(result) {
          let responseText = JSON.parse(result.responseText);
          let url = '/' + accountUrl + '/restricted_assets/' + responseText.restricted_asset_id + '/edit';
          Turbo.visit(url);
        }
      });

    });

  }

}